(() => {
  const updateVariant = (card, option) => {
    const image = card.querySelector('.sjd-wholesale-category__variant-main-image');
    const form = card.querySelector('[data-sjd-wholesale-product-form]');
    const selectedVariant = card.querySelector('[data-sjd-selected-variant]');
    const selectedSku = card.querySelector('[data-sjd-selected-sku]');
    const links = card.querySelectorAll('[data-sjd-variant-product-link]');
    const options = card.querySelectorAll('[data-sjd-variant-option]');
    const variantUrl = option.dataset.sjdVariantUrl || '';

    options.forEach((item) => {
      const active = item === option;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });

    if (image && option.dataset.sjdVariantImage) {
      image.src = option.dataset.sjdVariantImage;
      if (option.dataset.sjdVariantImageSrcset) image.srcset = option.dataset.sjdVariantImageSrcset;
      if (option.dataset.sjdVariantImageAlt) image.alt = option.dataset.sjdVariantImageAlt;
    }

    if (selectedVariant) selectedVariant.textContent = option.dataset.sjdVariantTitle || '';
    if (selectedSku) selectedSku.textContent = option.dataset.sjdVariantSku || '';
    links.forEach((link) => {
      if (variantUrl) link.href = variantUrl;
    });

    if (form) {
      form.dataset.sjdQuoteProductUrl = variantUrl || form.dataset.sjdQuoteProductUrl;
      form.dataset.sjdQuoteSku = option.dataset.sjdVariantSku || '';
      form.dataset.sjdQuoteVariantId = option.dataset.sjdVariantId || '';
      form.dataset.sjdQuoteVariantTitle = option.dataset.sjdVariantTitle || '';
    }
  };

  document.querySelectorAll('[data-sjd-variant-card]').forEach((card) => {
    card.querySelectorAll('[data-sjd-variant-option]').forEach((option) => {
      option.addEventListener('click', () => updateVariant(card, option));
    });
  });
})();
